module.exports = __webpack_public_path__ + "img/cattunnel14.bfbda509.jpg";